export const getFirstVisitFlag = () => {
  return localStorage.getItem("first_visit_flag");
};

export const setFirstVisitFlag = () => {
  return localStorage.setItem("first_visit_flag", "true");
};

export const getSelectedLocale = () => {
  return localStorage.getItem("selected_locale");
};
export const setSelectedLocale = (selectedLocale: string) => {
  return localStorage.setItem("selected_locale", selectedLocale);
};

export const setPublicKeyPem = (publicKey: string) => {
  return localStorage.setItem("public_key_pem", publicKey);
};

export const getPublicKeyPem = () => { 
  return localStorage.getItem("public_key_pem");
};

export const setPrivateKeyPem = (privateKey: string) => {
  return localStorage.setItem("private_key_pem", privateKey);
};

export const getPrivateKeyPem = () => {
  return localStorage.getItem("private_key_pem");
};

export const setSupervisorId = (supervisorId: string) => {
  return localStorage.setItem("supervisor_id", supervisorId);
};

export const getSupervisorId = () => {
  return localStorage.getItem("supervisor_id");
};

export const saveHistory = (items: string) => {
  return localStorage.setItem("supervisor_history", items);
};

export const getHistory = () => {
  return localStorage.getItem("supervisor_history");
}